import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
export default {
  data() {
    return {
      typeIndex: 0,
      typebtn: [],
      alltitle: '全部',
      typeclick: false,
      ulchildSstyle: {},
      ulchildClass: '',
      ctypeArr: [],
      fid: ''
    };
  },
  components: {},
  props: ['value'],
  computed: {
    computedProp() {
      return [this.value.typebtnstyle, this.value.posstyle];
    }
  },
  watch: {
    'value': {
      handler(val) {
        console.log(`value`, val);
      },
      deep: true
    },
    'value.typelist': {
      handler(val) {
        console.log(`value.typelist`, val);
        this.ctypeArr = val.length > 0 ? val.map(() => {
          return '';
        }) : [];
      },
      deep: true
    },
    // 'value.typebtnstyle': {
    //     handler (val) {
    //         this.typebtn = [...val]
    //     },
    //     deep: true
    // },
    'value.showtypeall': {
      handler(val) {
        if (this.typeclick) return;
        this.typeIndex = val ? 0 : 1;
      },
      deep: true
    },
    // 'value.posstyle': {
    //     handler (val) {
    //         this.getChildulStyle(val)
    //     },
    //     deep: true
    // },
    computedProp() {
      this.typebtn = [...this.value.typebtnstyle];
      this.getChildulStyle(this.value.posstyle);
    }
  },
  created() {
    this.fid = this.$route.query.fid;
  },
  mounted() {},
  methods: {
    /**
     * 分类点击事件
     */
    typeClick(item, index) {
      this.typeclick = true;
      this.typeIndex = index;
      this.ctypeArr = this.ctypeArr.map(() => {
        return '';
      });
      this.$emit('typeselect', {
        index: index,
        item: item
      });
    },
    childtypeClick(item, index, child, cIndex) {
      this.typeIndex = index;
      this.ctypeArr = this.ctypeArr.map(() => {
        return '';
      });
      this.ctypeArr[index - 1] = cIndex;
      this.$emit('typeselect', {
        index: index,
        item: item,
        child: child,
        cIndex: cIndex
      });
    },
    getChildren(item, type) {
      let nextLevel = [...JSON.parse(item.itemformdata.json.replace(/(<\/?p.*?>)/gi, ''))];
      return type === 0 ? nextLevel.length > 0 : nextLevel;
    },
    getChildulStyle(val) {
      console.log(`getChildulStyle`, val);
      console.log(`this.typebtn`, this.typebtn);
      // const margin = 0
      const margin = this.typebtn.length > 0 && this.typebtn[0].margin !== undefined ? Number(this.typebtn[0].margin.replace('vw', '')) : 0;
      console.log(`margin`, margin);
      let style = {};
      if (val.display && val.display === 'flex') {
        style.left = '-50%';
        if (val.top) style.top = '100%';
        if (val.bottom) style.bottom = '100%';
        this.ulchildClass = '';
      } else if (!val.display || val.display && val.display === 'block') {
        if (val.left) style.left = '100%';
        if (val.right) style.right = `100%`;
        style.width = `calc(100% + ${margin * 2}vw)`;
        this.ulchildClass = 'normal';
      }
      // console.log(`this.typebtn`, this.typebtn)
      this.ulchildSstyle = style;
    }
  }
};